// Centralized frontend build metadata — CalVer (YYYY.MM.BUILD)
// Auto-bumped by Vite on each production build.
export const FRONTEND_VERSION = '2026.09.8'
